import sectionCardBasicCss from '../css-snippets/section-card-basic';

const html = ` 
<style>${sectionCardBasicCss}</style>
<div
  id="card-basic-unique-id"
  data-id="unique-id"
  class="card-basic-wrapper"
  data-attribute="card-basic-wrapper"
  data-background-color="#14A16C"
  data-text-color="#ffffff"
  data-top-padding="true"
  data-bottom-padding="true"
  data-image-position="left"
  data-image-width="30"
  style="--background-color: #14a16c; --text-color: #ffffff; --image-width: 30%"
>
  <div data-attribute="card-basic-content" class="card-basic-content container">
    <div class="card-basic-image" data-attribute="card-basic-image">
      <img
        data-attribute="card-basic-image-inner"
        src="https://cdn.skyfastimg.com/images/2026/04/10/image-69d86c64f2ff258b7a0916d0.png?w=500&h=500&q=80"
        alt="img"
      />
    </div>
    <div
      class="card-basic-content-text"
      data-attribute="card-basic-content-text"
    >
      <div
        class="card-basic-content-text"
        data-attribute="card-basic-content-text"
      >
        <h2>Your purchase has purpose! With every order, Lignosus will: 1</h2>
        <ul>
          <li>
            Fund permanent carbon removal technologies through Stripe Climate.
          </li>
          <li>Plant a tree with our partner, Eden: People+Planet</li>
        </ul>
      </div>
    </div>
  </div>
</div>
`;
export default html;
